import { Box, Typography, Button, CircularProgress } from '@mui/material';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useState, useEffect } from 'react';
import AddIcon from '@mui/icons-material/Add';
import TransactionTable from './components/TransactionTable';
import { getCurrentUser, User } from '../services/userService';

const TransactionList = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const status = searchParams.get('status');
  const dateFilledStart = searchParams.get('dateFilledStart');
  const dateFilledEnd = searchParams.get('dateFilledEnd');
  const dateReceivedByNASHStart = searchParams.get('dateReceivedByNASHStart');
  const dateReceivedByNASHEnd = searchParams.get('dateReceivedByNASHEnd');
  
  const [currentUser, setCurrentUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCurrentUser = async () => {
      try {
        const user = await getCurrentUser();
        setCurrentUser(user);
      } catch (error) {
        console.error('Failed to fetch current user:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchCurrentUser();
  }, []);

  // Determine if user is a Broker
  const isBroker = currentUser?.role?.name === 'Broker';

  return (
    <Box sx={{ p: 3 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography variant="h4" gutterBottom>Transactions</Typography>
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={() => navigate('/transaction/add')}
        >
          Add Transaction
        </Button>
      </Box>
      
      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
          <CircularProgress />
        </Box>
      ) : (
        <TransactionTable 
          initialFilter={{
            status: status || undefined,
            dateFilledStart: dateFilledStart || undefined,
            dateFilledEnd: dateFilledEnd || undefined,
            dateReceivedByNASHStart: dateReceivedByNASHStart || undefined,
            dateReceivedByNASHEnd: dateReceivedByNASHEnd || undefined,
            // Add organizationId filter for Broker users
            ...(isBroker && currentUser?.organizationId ? { organizationId: currentUser.organizationId } : {})
          }}
        />
      )}
    </Box>
  );
};

export default TransactionList;
